import { useCallback, useContext, useEffect, useState } from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { ApiProvider } from '@leverege/api-redux';
import { Popup, Selector, Toast } from '@leverege/ui-elements';
import S from './PTZPresetsAction.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'ui-video.actions.PTZPresets',
  matches: {
    use: 'videoOptionsBar'
  },
  layout: {
    sort: 'aaa'
  },
  handles: () => {
    const roles = GlobalState.get()?.ui?.personas || [];

    // for admin eyes only
    return roles.some(role => role.name === 'default');
  },
  customComponent: PTZPresetSelector
};
function PTZPresetSelector({
  context
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [moving, setMoving] = useState(false);
  const [error, setError] = useState(null);
  const [value, setValue] = useState();
  const {
    clientProps: {
      delegate
    }
  } = context;
  const api = useContext(ApiProvider.Context);
  useEffect(() => {
    const load = async () => {
      if (api && delegate) {
        try {
          const interfaceUrl = delegate.getInterfaceUrl();
          setLoading(true);
          let {
            presets
          } = await api.child(`v1/interface/${interfaceUrl}.srv/streamProxy/ptz/preset`).get();
          presets = presets.map(preset => {
            const [, data] = preset.split(/=(.*)/);
            const [name, position] = data.split(/:(.*)/);
            const [pan, tilt, zoom] = position.split(':');
            return {
              name,
              help: `${pan} ${tilt} ${zoom}`,
              value: name
            };
          });
          setOptions(presets);
          setValue(presets?.[0]);
        } catch (err) {
          setError(err);
        }
        setLoading(false);
      }
    };
    load();
  }, []);
  const renderTitle = useCallback(value => {
    if (error) {
      return 'Error Loading Presets';
    }
    if (moving) {
      return /*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-spinner fa-spin"
      });
    }
    if (loading) {
      return 'Loading Presets...';
    }
    return value?.value || 'None';
  }, [loading, moving, error]);
  const renderer = useCallback((value, name, checked) => {
    const {
      help
    } = value;
    return /*#__PURE__*/_jsx(Popup.Item, {
      help: help,
      value: value?.value,
      eventData: value?.data,
      checked: checked,
      children: name
    });
  }, []);
  const onChange = useCallback(async evt => {
    try {
      const interfaceUrl = delegate.getInterfaceUrl();
      setMoving(true);
      await api.child(`v1/interface/${interfaceUrl}.srv/streamProxy/ptz`).patchRaw({
        preset: evt.value
      });
      setValue(evt.value);
      setMoving(false);
    } catch (err) {
      console.error(err);
      Toast.error(['Error setting ptz coordinates', err.message]);
    }
  }, [api, delegate]);
  return /*#__PURE__*/_jsx(Selector, {
    "data-error": error,
    disabled: loading || moving || error,
    toggleVariant: "videoPtzPresets",
    className: S.toggle,
    values: options,
    value: value,
    title: renderTitle,
    onChange: onChange,
    renderer: renderer
  });
}